import { PartialType, PickType } from '@nestjs/swagger';
import { SpBuilderBoardTypeDto } from './sp-builder-board-type.dto';
import { SpBuilderBoardTypeUpdatableInterface } from '../interfaces/sp-builder-board-type-updatable.interface';

export class SpBuilderBoardTypeUpdateDto
  extends PartialType(PickType(SpBuilderBoardTypeDto, ['active']))
  implements SpBuilderBoardTypeUpdatableInterface {}
